import React, { Fragment } from "react";
import { FormikProps } from "formik";
import { isEmpty, noop } from "lodash";
import { useHistory } from "react-router";
import PageTitle from "../../components/Ui/PageTitle";
import { Button, Col, Row } from "react-bootstrap";
import ProductConfigurator from "../../components/RealtimeProductConfigurator";
import CreateOrderButton from "../../components/CreateOrderButton";
import { valuesToProduct } from "../../utils/ProductFormHelpers";
import { OrderCategory, TApiOrderDetails } from "../../api/endpoints/Order";
import { paths } from "../../router";
import { useDispatch, useSelector } from "react-redux";
import { addProductToBasket } from "../../store/action-creators/basket";
import { TApiSubset } from "../../api/endpoints/Subset";
import { TApiSubsetOptions } from "../../api/endpoints/SubsetOption";
import { IProductFormValues } from "../../components/RealtimeProductConfigurator/ProductForm";

import { isLoggedIn } from "../../store/selectors/UserSelectors";

const RealtimeProductNew = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isUserLoggedIn = useSelector(isLoggedIn);

  const onOrderSaved = (order: TApiOrderDetails) => {
    history.push(paths.order(order.id))
  };

  const onAddToBasket = (
    subset: TApiSubset,
    subsetOptions: TApiSubsetOptions,
    formik: FormikProps<IProductFormValues>
  ) => {
    formik.submitForm().then(() => {
      // Workaround for for a bug in formik where submitForm method does not reject the promise when validation fails
      // See: https://github.com/formium/formik/issues/1580
      formik.validateForm(formik.values).then(errors => {
        if (isEmpty(errors)) {
          dispatch(addProductToBasket(valuesToProduct(subset, subsetOptions, formik.values)));
          history.push(paths.root);
        }
      }).catch(noop);
    }).catch(noop)
  }

  return (
    <Fragment>
      <Row>
        <Col>
          <PageTitle title="Configure product" />
        </Col>
      </Row>

      <ProductConfigurator
        actions={
          (subset, subsetOptions, formik) => {
            return (
              <Fragment>
                {
                  isUserLoggedIn &&
                  <CreateOrderButton
                    formik={formik}
                    onSuccess={onOrderSaved}
                    orderProps={
                      {
                        category: OrderCategory.REALTIME,
                        folder_id: null,
                        products: formik.values ? [valuesToProduct(subset, subsetOptions, formik.values)] : []
                      }
                    }
                  />
                }
                <Button onClick={() => onAddToBasket(subset, subsetOptions, formik)}>
                  Add to basket
                </Button>
              </Fragment>
            )
          }
        }
      />
    </Fragment>
  )
}

export default RealtimeProductNew;
